import React, { useEffect, useMemo } from "react";

export const useMutationObserver = ({ target, options = {}, callback }) => {
  const observer = useMemo(
    () =>
      new MutationObserver((mutationRecord, mutationObserver) => {
        callback(mutationRecord, mutationObserver);
      }),
    [callback]
  );

  useEffect(() => {
    const element = target.current;
    if (observer && element) {
      observer.observe(element, options);
      return () => observer.disconnect();
    }
  }, [target, observer, options]);
};
